var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"md",class:_vm.size,style:({ 'background-color': _vm.status.color }),attrs:{"pill":"","variant":""}},[_vm._v(_vm._s(_vm.status.name))])}
var staticRenderFns = []

export { render, staticRenderFns }